import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getProviders = ({ currencyId, pageNumber }) => {
  return axios.get(`/paymentMethod/mm/${currencyId}/${pageNumber}`);
};

export const useMobileMoneyProviders = ({ currencyId, pageNumber, config }) => {
  return useQuery({
    ...config,
    queryKey: ['currency__mobile_money_providers', currencyId, pageNumber],
    queryFn: () => getProviders({ currencyId, pageNumber }),
  });
};
